import { render, staticRenderFns } from "./AddSubDivisionDlg.vue?vue&type=template&id=a86bc1f8&"
import script from "./AddSubDivisionDlg.vue?vue&type=script&lang=js&"
export * from "./AddSubDivisionDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports